import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { api, errMsg } from "@/lib/api";

export default function AuditLog() {
  const [rows, setRows] = useState([]);
  const [q, setQ] = useState("");
  useEffect(() => {
    const t = setTimeout(() => api.get("/audit", { params: { q, limit: 300 } }).then(({ data }) => setRows(data)).catch((e) => toast.error(errMsg(e))), 250);
    return () => clearTimeout(t);
  }, [q]);
  return (
    <div className="space-y-6" data-testid="audit-page">
      <div>
        <h1 className="font-display text-4xl sm:text-5xl font-extrabold tracking-tight">Registro attività</h1>
        <p className="text-sm text-stone-500 mt-1">Chi ha visto, modificato, inviato o esportato cosa e quando.</p>
      </div>
      <Input placeholder="Filtra per azione o utente…" value={q} onChange={(e) => setQ(e.target.value)} className="max-w-sm" data-testid="audit-filter-input" />
      <div className="overflow-x-auto rounded-2xl border bg-white">
        <table className="w-full text-sm" data-testid="audit-table">
          <thead className="bg-stone-50 text-left text-xs uppercase tracking-wide text-stone-500">
            <tr><th className="p-3">Data/ora</th><th className="p-3">Utente</th><th className="p-3">Azione</th><th className="p-3">Oggetto</th><th className="p-3">Dettagli</th></tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id} className="border-t">
                <td className="p-3 whitespace-nowrap">{new Date(r.ts).toLocaleString("it-IT")}</td>
                <td className="p-3">{r.user}</td>
                <td className="p-3 font-mono text-xs">{r.action}</td>
                <td className="p-3 text-xs text-stone-500">{r.entity} {r.entity_id}</td>
                <td className="p-3 text-xs text-stone-600">{r.details}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
